<template>
  <div>
    <a-list itemLayout="vertical" :loading="!resume">
      <a-list-item>
        <a-list-item-meta>
          <h2 slot="title">{{ resume.name }}</h2>
          <a-row slot="description">
            <a-col>
              <span>{{ resume.gender_id | sexy }}</span>
              <a-divider type="vertical"></a-divider>
              <span>{{ resume.city_name }}</span>
              <a-divider type="vertical"></a-divider>
              <span>{{ resume.education_name }}</span>
              <a-divider type="vertical"></a-divider>
              <span>{{ resume.working_years_name }}工作经验</span>
            </a-col>
            <a-col>
              <span>{{ resume.title }}</span>
              <a-divider type="vertical"></a-divider>
              <span>{{ resume.last_company }}</span>
            </a-col>
            <a-col style="paddingTop:10px">
              <a-icon type="mobile" style="font-size: 18px;margin-right:8px;"></a-icon>
              <span>{{ resume.mosaic_mobile | formatText }}</span>
              <a-divider type="vertical"></a-divider>
              <a-icon type="mail" style="font-size: 18px;margin-right:8px;"></a-icon>
              <span>{{ resume.email }}</span>
            </a-col>
          </a-row>
        </a-list-item-meta>
        <a-row slot="extra" v-if="Object.keys(latest_post).length">
          <a-col>
            <h3>
              最近一次做单：
              <a>{{ latest_post.order_no }}</a>
            </h3>
            <h4>
              推荐进度：
              <span style="color:red;">{{ latest_post.status_text }}</span>
            </h4>
            <h4>推荐职位：{{ latest_post.job_name }}</h4>
            <h4>推荐公司：{{ latest_post.job_company_name }}</h4>
          </a-col>
        </a-row>
      </a-list-item>
    </a-list>
    <a-divider></a-divider>
    <a-collapse accordion :defaultActiveKey="edition[0].id" :bordered="false" v-if="edition">
      <template v-for="item in edition">
        <a-collapse-panel :header="item._edition" :key="item.id">
          <resume-detail-list
            @view="showDrawer"
            @viewResume="$refs.preview.show(item.attachment)"
            :record="item"
          ></resume-detail-list>
        </a-collapse-panel>
      </template>
    </a-collapse>
    <a-drawer :visible="drawer" width="800" @close="drawer = !drawer" :destroyOnClose="true">
      <resume-report-modal></resume-report-modal>
    </a-drawer>
    <resume-preview-modal ref="preview"></resume-preview-modal>
  </div>
</template>
<script>
import ResumeDetailList from "./resume-detail-list";
import ResumeReportModal from "./resume-report-modal";
import ResumePreviewModal from "@/components/resume-preview-modal";
import Api from "@/api";
import { NumberToChinese } from "@/shared/utils/common";
export default {
  name: "ResumeDetail",
  props: {
    id: {
      default: -1
    }
  },
  data() {
    return {
      drawer: false,
      resume: "",
      latest_post: "",
      edition: undefined
    };
  },
  components: {
    ResumeDetailList,
    ResumeReportModal,
    ResumePreviewModal
  },
  computed: {
    resume_id() {
      if (this.id < 0) {
        return this.$route.params.id;
      } else {
        return this.id;
      }
    }
  },

  async created() {
    await this.getData();
    this.getEditionData();
  },

  mounted() {},

  methods: {
    showDrawer() {
      this.drawer = true;
    },
    async getData() {
      let { resume, latest_post } = await Api.resume.getDetail({
        resume_id: this.resume_id
      });
      this.resume = resume;
      this.latest_post = latest_post;
    },
    async getEditionData() {
      let params = {
        mobile: this.resume.mobile,
        limit: 2000,
        page: 1
      };
      let { list } = await Api.resume.getEditionList(params);
      list.forEach((item, index) => {
        let c = NumberToChinese(++index);
        item._edition = "版本" + c;
      });
      this.edition = list;
    }
  }
};
</script>
